import React from 'react';
import { useRecoilValue } from 'recoil';
import { allWheelhousesState } from 'features/file-browser/state/fileAtoms';
import { isVisibleWheelhouseState } from 'features/three-view/state/threeAtoms';
import { StlViewer } from '../utils/stlViewer';

export const WheelhouseViewer: React.FC = () => {
  const allWheelhouses = useRecoilValue(allWheelhousesState);
  const isVisibleWheelhouse = useRecoilValue(isVisibleWheelhouseState);

  if (!allWheelhouses.length || !isVisibleWheelhouse) return <></>;

  const getFileName = (name: string) => {
    return name.split('.').slice(0, -1).join('.');
  };

  return (
    <>
      {allWheelhouses.map((s3file, index) => (
        <StlViewer
          key={`${s3file.url}-${index}`}
          url={s3file.url}
          name={getFileName(s3file.name)}
          defaultColor={'#ffff00ff'}
          label='Wheelhouse'
        />
      ))}
    </>
  );
};
